/* eslint-disable class-methods-use-this */
import Modal from 'backbone.modal';
import CartItemsView from './cartItemsView';
import CartItems from './cartItems';
import resourcesCart from './resourcesCart';
import selectors from './selectors';
import updateCartCount from './updateCartCount';
import connectSortable from './connectSortable';

// Create the modal view.
class CartItemsModal extends Modal {

	// Backbone settings.
	get template() {
		// eslint-disable-line
		if ($(selectors.template.container).length) {
			return _.template(
				$(selectors.template.container).html(),
			);
		}
		return null;
	}

	get events() {
		return {
			'click .previous': 'previousStep',
			'click .next.active': 'nextStep',
			'click .bbm-modal__button': CartItemsModal.onButtonClick,
			'click #vtc-cart-collection-all': CartItemsModal.toggleAllCartItems,
		};
	}

	/**
	 * On toggle all change event.
	 *
	 * @param  {object} event The event object.
	 * @return void
	 */
	static toggleAllCartItems(event) {
		const { checked } = event.target;
		CartItems.each((cartItem) => cartItem.save({ selected: checked }));
	}

	static onButtonClick(event) {
		const elem = $(event.currentTarget);
		if (elem.hasClass('remove')) {
			this.clearCart('selected');
		}
	}

	initialize() {
		const { template } = selectors;
		// Backbone Modal settings.
		this.viewContainer = '.vtc-bbm-modal';
		this.submitEl = '.submit-cart';
		this.cancelEl = '.bbm-modal__close';
		this.keyControl = false;

		if ($(template.cart).length && $(template.form).length) {
			this.views = {
				'click #cart': {
					view: _.template(
						$(template.cart).html(),
					),
				},
				'click #cart-form': {
					view: _.template(
						$(template.form).html(),
					),
				},
			};
		}

		CartItems.fetch();
		this.listenTo(CartItems, 'change', this.cartItemCheck);
	}

	previousStep(e) {
		e.preventDefault();
		this.previous();
		this.maybeShowEmptyCart();
		this.maybeRenderTheCart();
		this.maybeScrollToTop();
		this.maybeToggleTheSearchSection();
	}

	nextStep(e) {
		e.preventDefault();
		this.next();
		this.maybeScrollToTop();
		this.maybeCloneTheForm();
		this.maybeToggleTheSearchSection();
		this.addTinyMceToComments();
	}

	/**
	 * On Modal Show Event.
	 *
	 * @return void
	 */
	onShow() {
		this.maybeRenderTheCart();
		this.maybeCloneTheForm();
		this.maybeToggleTheSearchSection();
	}

	maybeToggleTheSearchSection() {
		const search = $(selectors.search.wrapper);
		if (this.currentIndex === 1) {
			search.hide();
		} else {
			search.show();
		}
	}

	maybeRenderTheCart() {
		const { table } = selectors;

		const cartItemsView = new CartItemsView({
			collection: CartItems,
		});

		cartItemsView.render();

		// If all cart items are selected make sure to also check the all checkbox.
		this.cartItemCheck();

		if (this.$el.find(table.table).length) {
			connectSortable(this.$el.find(table.body)[0]);
		} else {
			setTimeout(
				(modal) => {
					if (modal.$el.find(table.table).length) {
						connectSortable(this.$el.find(table.body)[0]);
					}
				},
				200,
				this,
			);
		}
	}

	maybeScrollToTop() {
		$('#main').get(0).scrollIntoView(true);
	}

	maybeCloneTheForm() {
		const { form } = selectors;
		const {
			clone,
			gfWrapper,
			spinner,
			wrapper,
			hiddenInput,
		} = form;

		if (!resourcesCart.ajaxFormClone.length) {
			const $form = $(clone).find(gfWrapper);
			resourcesCart.ajaxFormClone = $form.clone(true, true);
		} else {
			resourcesCart.ajaxFormClone.find(spinner).remove();
		}
		setTimeout(
			(modal) => {
				if (modal.$el.find(wrapper).length) {
					$(wrapper).replaceWith(resourcesCart.ajaxFormClone);
					const selected = CartItems.sort().selected();
					const prepared = selected.map(
						(model) => `${model.get('resourceId')}:${model.get('language')}`,
					).join(',');
					$(gfWrapper).find(hiddenInput).first().val(prepared);
				}
			},
			200,
			this,
		);
	}

	maybeShowEmptyCart() {
		const { cart } = selectors;
		if (!CartItems.length) {
			$(cart.wrapper).hide();
			$(cart.empty).show();
		}
	}

	addTinyMceToComments() {
		setTimeout(() => {
			if (tinymce) {
				tinymce.remove();
				tinymce.init({
					selector: 'textarea',
					setup(editor) {
						editor.on('change', () => {
							editor.save();
						});
					},
					menubar: false,
					plugins: ['lists'],
					toolbar: 'bold italic underline | bullist numlist',
				});
			}
		}, 1000);
	}

	/**
	 * On cart item check change event.
	 *
	 * @return void
	 */
	cartItemCheck() {
		const { actions } = selectors.cart;

		const unselected = CartItems.unSelected().length;
		const selected = CartItems.selected().length;
		const container = this.$el.find(actions.wrapper);
		const checkAll = $(actions.all);
		const buttons = {
			download: container.find(actions.download),
			remove: container.find(actions.remove),
		};

		checkAll.prop('checked', !unselected);

		if (selected) {
			buttons.download.addClass('active');
			buttons.remove.addClass('active');
		} else {
			buttons.download.removeClass('active');
			buttons.remove.removeClass('active');
		}
	}

	/**
	 * Method to clear cart.
	 *
	 * @return void
	 */
	clearCart(selection) {
		const { cart } = selectors;
		const selected = CartItems.selected();
		const unselected = CartItems.unSelected();

		// If the button clicked is the remove cart items, remove only the selected ones.
		selected.forEach((cartItem) => {
			cartItem.destroy();
		});

		// Also remove unselected items, if a request to delete all items was fired.
		if (selection !== 'selected') {
			unselected.forEach((cartItem) => {
				cartItem.destroy();
			});
		}

		// Update the cart count from header.
		updateCartCount(); // eslint-disable-line

		const count = selection === 'selected'
			? selected.length
			: CartItems.length;

		const container = this.$el.find(cart.actions.wrapper).find(cart.actions.download);

		if (!count) {
			container.removeClass('active');
		} else {
			container.addClass('active');
		}

		if (selection === 'selected') {
			this.maybeShowEmptyCart();
		}
	}
}

export default CartItemsModal;
